import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-4">
            漫评解说
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            精彩漫评
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            深度解析热门漫画，带你发现更多好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-background-50/90 backdrop-blur-sm rounded-full group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-background-950/70 backdrop-blur-sm text-background-50 text-xs rounded-md">
                  {item.duration}
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}